// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__21_Nj","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1Rl0K"};